module.exports = {
      id: "illustrations:NZ03-usage",
      viewBox: "0 0 321 355",
      url: "/static/" + "sprites.1e5806fb7235408b9281f0924c9110c8.svg#illustrations:NZ03-usage",
      toString: function () {
        return this.url;
      }
    }